import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15ff6c67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "scanner" }
const _hoisted_4 = { class: "product" }
const _hoisted_5 = { class: "product-info" }
const _hoisted_6 = { class: "location" }
const _hoisted_7 = { class: "product-count" }
const _hoisted_8 = { slot: "end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ShopifyImg = _resolveComponent("ShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_LocationPopover = _resolveComponent("LocationPopover")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_back_button, {
                "default-href": "/",
                slot: "start"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Shipment Details")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    disabled: !_ctx.hasPermission(_ctx.Actions.APP_SHIPMENT_ADMIN),
                    onClick: _ctx.addProduct
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("p", { class: "overline" }, _toDisplayString(_ctx.current.externalOrderId), 513), [
                      [_vShow, _ctx.current.externalOrderId]
                    ]),
                    (_ctx.current.externalId)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.$t("External ID")) + ": " + _toDisplayString(_ctx.current.externalId), 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t("Shipment ID")) + ": " + _toDisplayString(_ctx.current.shipmentId), 1))
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_ion_chip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.current.trackingIdNumber), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.current.trackingIdNumber]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Scan items")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    autofocus: "",
                    placeholder: _ctx.$t('Scan barcodes to receive them'),
                    modelValue: _ctx.queryString,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryString) = $event)),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.updateProductCount()), ["enter"]))
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                expand: "block",
                fill: "outline",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scanCode()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.barcodeOutline
                  }, null, 8, ["icon"]),
                  _createTextVNode(_toDisplayString(_ctx.$t("Scan")), 1)
                ]),
                _: 1
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.items, (item) => {
              return (_openBlock(), _createBlock(_component_ion_card, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_thumbnail, {
                            slot: "start",
                            onClick: ($event: any) => (_ctx.openImage(_ctx.getProduct(item.productId).mainImageUrl, _ctx.getProduct(item.productId).productName))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ShopifyImg, {
                                src: _ctx.getProduct(item.productId).mainImageUrl
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.productHelpers.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId))), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.productHelpers.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.productId))), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(item.productId).productFeatures)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_LocationPopover, {
                        item: item,
                        type: "shipment",
                        facilityId: _ctx.currentFacility.facilityId
                      }, null, 8, ["item", "facilityId"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "floating" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Qty")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            type: "number",
                            min: "0",
                            modelValue: item.quantityAccepted,
                            "onUpdate:modelValue": ($event: any) => ((item.quantityAccepted) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  (item.quantityOrdered > 0)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        lines: "none",
                        class: "border-top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: ($event: any) => (_ctx.receiveAll(item)),
                            slot: "start",
                            fill: "outline"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Receive All")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_ion_progress_bar, {
                            color: _ctx.getRcvdToOrdrdFraction(item) > 1 ? 'danger' : 'primary',
                            value: _ctx.getRcvdToOrdrdFraction(item)
                          }, null, 8, ["color", "value"]),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(item.quantityOrdered), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createVNode(_component_ion_fab, {
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_fab_button, {
                disabled: !_ctx.hasPermission(_ctx.Actions.APP_SHIPMENT_UPDATE) || !_ctx.isEligibleForReceivingShipment(),
                onClick: _ctx.completeShipment
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.checkmarkDone }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}